import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const PowerpointIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 36 36" {...props}>
    <rect width="100%" height="100%" rx="4" fill="#C23918" />
    <path
      d="M18.3062 7.51724C20.3405 7.38895 22.3551 7.9799 23.9978 9.18675C24.6752 9.81337 25.1989 10.5879 25.5279 11.4501C25.857 12.3122 25.9826 13.2387 25.8949 14.1574C25.943 15.4329 25.607 16.6934 24.9305 17.7758C24.254 18.8582 23.2682 19.7126 22.1006 20.2283C20.7975 20.8441 19.3674 21.1431 17.9268 21.101H14.1324V28.5H10.0725V7.63107L18.3062 7.51724ZM14.1324 17.9517H17.6233C18.7294 18.0235 19.8234 17.6859 20.6967 17.0031C21.0583 16.6578 21.3405 16.238 21.524 15.7729C21.7074 15.3077 21.7876 14.8083 21.7591 14.3091C21.7591 12.0325 20.3931 10.8563 17.7371 10.8563H14.1324V17.9517Z"
      fill="white"
    />
  </Icon>
)
